export default {
  props: {
    media: {
      type: Array,
      required: true
    }
  },
  methods: {
    getPreset(image) {
      if (image?.data?.preset) {
        return image.data.preset
      }
      if (image?.preset) {
        return image.preset
      }
      return '__original'
    },
    getRatio(image) {
      // Not set is here for consistency with Features and Highlights, which are required to
      // still function without a defined icon ratio for backwards compatibility.
      if (image?.data?.iconratio) {
        return image.data.iconratio !== 'notset' ? image.data.iconratio : ''
      }
      return '16-9'
    }
  }
}
